
import { destroy, get, getOne, post, put } from "../apis/httpClient"

export const pagingArea=(params)=>get('/api/v1/areaFactory/paging',params)
export const detailArea=(query)=>getOne(`/api/v1/areaFactory/detail/${query}`)
export const updateArea=(body)=>put(`/api/v1/areaFactory/update`,body)
export const createArea=(body)=>post(`/api/v1/areaFactory/create`,body)
export const deleteArea=(body)=>destroy(`/api/v1/areaFactory/delete`,body)
export const listArea=()=>get(`/api/v1/areaFactory/list`)
